import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=989da054&scoped=true&lang=pug&"
import script from "./NavMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuItem.vue?vue&type=style&index=0&id=989da054&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989da054",
  null
  
)

export default component.exports